import e from "./highrise1466.mjs";
import o from "./highrise1334.mjs";
import r from "./highrise1335.mjs";
var a = r && r.isTypedArray, s = a ? o(a) : e;
export {
  s as default
};
